import { Button, Tooltip } from 'antd';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import MenuLabelEdit from './MenuLabelEdit';
import { SocketContext } from '../../../App';
import { useContext, useEffect, useRef } from 'react';

export default function MenuLabel(props: any) {

    const ref = useRef<any>(undefined);

    /** api服务id */
    const apiId = 'menuLabel';

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }

        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ branchStoreId: contextData?.currentBranchStoreId })
            }
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    const onRefresh = (item: any) => {
        const { branchStoreId } = item;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                branchStoreId
            }
        }
        ref.current.initData(currentData);

        setContextData({ ...contextData, refresh: false })
    }

    //表头
    const columnsHead = [
        {
            title: '门店',
            dataIndex: 'branchStoreName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.branchStore.brand.brandName + " " + record.branchStore.branchStoreName}</div>
                )
            }
        },
        {
            title: '标签名称',
            dataIndex: 'menuLabelName',
        },
        {
            title: '字体颜色',
            dataIndex: 'fontColor',
            render: (text: any, record: any) => {
                return (
                    <Tooltip placement="topLeft" title={record.fontColor}>
                        <div><Button style={{ backgroundColor: record.fontColor }}></Button></div>
                    </Tooltip>

                )
            }
        },
        {
            title: '背景颜色',
            dataIndex: 'backgroundColor',
            render: (text: any, record: any) => {
                return (
                    <Tooltip placement="topLeft" title={record.backgroundColor}>
                        <div><Button style={{ backgroundColor: record.backgroundColor }}></Button></div>
                    </Tooltip>
                )
            }
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '菜式标签',
        apiId: 'menuLabel',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: MenuLabelEdit,
        // sendPageData: { branchStoreId: localStorage.getItem("currentBranchStoreId") },
        sendPageData: { branchStoreId: contextData?.currentBranchStoreId },
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        }
    };

    return (
        <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
    )
}